'use client';
import { useState } from 'react';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import WhatsAppFloat from '@/components/WhatsAppFloat';
import {
  ArrowRight,
  CheckCircle2,
  ChevronDown,
  CalendarDays,
  MapPin,
  MessageCircle,
  ShieldCheck,
  Users,
  BriefcaseBusiness,
  Plane,
  Route,
  Armchair,
  Gauge,
  Luggage,
} from 'lucide-react';
const WA_NUMBER = '6287786556067';
const units = [
  {
    id: 'reborn',
    name: 'Toyota Innova Reborn',
    category: 'Family MPV',
    capacity: '6–7 Penumpang',
    transmission: 'Manual / Matic',
    fuel: 'Diesel',
    exterior: '/assets/images/REBORN.jpeg',
    interior: '/assets/images/REBORN-interior 1.jpeg',
    interior2: '/assets/images/REBORN-interior 2.jpeg', // ✅ tambah foto ke-2
    altExterior: 'Toyota Innova Reborn untuk rental mobil Tangerang NAYVERA',
    altInterior: 'Interior Toyota Innova Reborn NAYVERA',
    altInterior2: 'Interior kedua Toyota Innova Reborn NAYVERA', // ✅ tambah alt
    description:
      'Pilihan kendaraan untuk perjalanan keluarga, perjalanan bisnis, kunjungan kerja, dan perjalanan luar kota dengan kabin yang nyaman.',
    advantages: [
      'Kabin nyaman untuk perjalanan keluarga',
      'Cocok untuk perjalanan dalam dan luar kota',
      'Pilihan untuk kebutuhan pribadi maupun bisnis',
    ],
  },
  {
    id: 'zenix',
    name: 'Toyota Innova Zenix G',
    category: 'Executive MPV',
    capacity: '6–7 Penumpang',
    transmission: 'Matic',
    fuel: 'Bensin / Hybrid',
    exterior: '/assets/images/ZENIX G.webp',
    interior: '/assets/images/ZENIX G-interior 1.jpeg',
    interior2: '/assets/images/ZENIX G-interior 2.jpeg', // ✅ tambah foto ke-2
    altExterior: 'Toyota Innova Zenix G untuk rental mobil Tangerang NAYVERA',
    altInterior: 'Interior Toyota Innova Zenix G NAYVERA',
    altInterior2: 'Interior kedua Toyota Innova Zenix G NAYVERA', // ✅ tambah alt
    description:
      'MPV modern untuk perjalanan keluarga maupun bisnis yang membutuhkan kabin lega, tampilan modern, dan kenyamanan selama perjalanan.',
    advantages: [
      'Desain modern untuk berbagai kebutuhan',
      'Cocok untuk keluarga dan perjalanan bisnis',
      'Kabin lega untuk perjalanan yang nyaman',
    ],
  },
  {
    id: 'venturer',
    name: 'Toyota Innova Venturer',
    category: 'Premium Family',
    capacity: '6–7 Penumpang',
    transmission: 'Matic',
    fuel: 'Diesel',
    exterior: '/assets/images/Venturer.jpeg',
    interior: '/assets/images/Venturer-interior 1.webp',
    interior2: '/assets/images/Venturer-interior 2.jpeg', // ✅ tambah foto ke-2
    altExterior: 'Toyota Innova Venturer untuk rental mobil Tangerang NAYVERA',
    altInterior: 'Interior Toyota Innova Venturer NAYVERA',
    altInterior2: 'Interior kedua Toyota Innova Venturer NAYVERA', // ✅ tambah alt
    description:
      'Pilihan Innova dengan tampilan lebih premium untuk perjalanan keluarga, tamu perusahaan, perjalanan bisnis, maupun kebutuhan khusus.',
    advantages: [
      'Tampilan premium dan elegan',
      'Sesuai untuk perjalanan bisnis dan keluarga',
      'Pilihan untuk kebutuhan transportasi eksekutif',
    ],
  },
];
const services = [
  {
    icon: CalendarDays,
    title: 'Sewa Harian',
    description:
      'Pilihan kendaraan Innova untuk kebutuhan harian, perjalanan keluarga, aktivitas kerja, dan mobilitas di Tangerang.',
  },
  {
    icon: Users,
    title: 'Dengan Driver',
    description:
      'Perjalanan lebih praktis dengan driver untuk kebutuhan pribadi, keluarga, tamu perusahaan, maupun perjalanan bisnis.',
  },
  {
    icon: ShieldCheck,
    title: 'Lepas Kunci',
    description:
      'Pilihan lepas kunci tersedia untuk unit tertentu sesuai persyaratan, ketentuan, dan ketersediaan kendaraan.',
  },
  {
    icon: Plane,
    title: 'Antar Jemput Bandara',
    description:
      'Kebutuhan perjalanan menuju atau dari Bandara Internasional Soekarno-Hatta dapat dikonsultasikan dengan admin.',
  },
  {
    icon: BriefcaseBusiness,
    title: 'Perjalanan Bisnis',
    description:
      'Kendaraan untuk meeting, kunjungan klien, perjalanan dinas, penjemputan tamu, dan kebutuhan perusahaan.',
  },
  {
    icon: Route,
    title: 'Perjalanan Luar Kota',
    description:
      'Kendaraan dapat digunakan untuk rute luar kota sesuai tujuan, durasi, jenis layanan, dan ketentuan sewa.',
  },
];
const areas = [
  'Tangerang Kota',
  'Tangerang Selatan',
  'BSD',
  'Bintaro',
  'Gading Serpong',
  'Alam Sutera',
  'Karawaci',
  'Cipondoh',
  'Ciledug',
  'Serpong',
  'Cikokol',
  'Kawasan Bandara Soekarno-Hatta',
];
const faqs = [
  {
    question: 'Berapa harga sewa Innova di Tangerang?',
    answer:
      'Harga sewa menyesuaikan tipe Innova, tanggal penggunaan, durasi, tujuan perjalanan, serta pilihan dengan driver atau lepas kunci. Hubungi admin NAYVERA untuk mendapatkan informasi harga dan paket yang sesuai.',
  },
  {
    question: 'Apa perbedaan Innova Reborn, Zenix, dan Venturer?',
    answer:
      'Ketiganya memiliki karakter dan kelengkapan yang berbeda. Reborn cocok untuk kebutuhan keluarga dan perjalanan bisnis, Zenix menawarkan desain lebih modern, sedangkan Venturer memiliki tampilan yang lebih premium. Pilihan unit dapat disesuaikan dengan kebutuhan dan ketersediaan.',
  },
  {
    question: 'Apakah tersedia sewa Innova lepas kunci?',
    answer:
      'Pilihan lepas kunci dapat tersedia untuk unit tertentu. Persyaratan, dokumen, dan ketersediaannya perlu dikonfirmasi kepada admin sebelum pemesanan.',
  },
  {
    question: 'Apakah tersedia sewa Innova dengan driver?',
    answer:
      'Ya, layanan dengan driver dapat dikonsultasikan untuk perjalanan keluarga, bisnis, perjalanan dinas, antar jemput bandara, maupun perjalanan luar kota.',
  },
  {
    question: 'Apakah Innova bisa digunakan untuk perjalanan luar kota?',
    answer:
      'Bisa untuk rute yang disetujui. Sampaikan tujuan, tanggal, durasi, dan jenis layanan kepada admin agar ketentuan perjalanan dapat dikonfirmasi terlebih dahulu.',
  },
  {
    question: 'Bagaimana cara memesan mobil Innova?',
    answer:
      'Pilih unit yang diinginkan, lalu hubungi admin melalui WhatsApp. Sampaikan tanggal sewa, waktu penggunaan, lokasi penjemputan, tujuan, jumlah penumpang, dan jenis layanan.',
  },
];
function createWhatsAppUrl(unitName: string) {
  const message = `Halo NAYVERA INDO TRANSPORT,
Saya ingin menanyakan ketersediaan sewa mobil Innova Tangerang.
DATA PEMESANAN
Kendaraan: ${unitName}
Jenis Sewa: Dengan Driver / Lepas Kunci
Tanggal Sewa:
Jam Mulai:
Jam Selesai:
Lokasi Penjemputan:
Tujuan / Rute:
Jumlah Penumpang:
Mohon informasi mengenai ketersediaan unit, harga dan paket sewa, fasilitas, syarat dan ketentuan, serta biaya tambahan jika ada.
Terima kasih.`;
  return `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(message)}`;
}
function PhotoPlaceholder({
  path,
  alt,
  label,
  className = '',
}: {
  path: string;
  alt: string;
  label: string;
  className?: string;
}) {
  const [imageFailed, setImageFailed] = useState(false);
  return (
    <div
      className={`relative overflow-hidden rounded-2xl bg-slate-100 ${className}`}
    >
      {!imageFailed ? (
        <img
          src={path}
          alt={alt}
          className="absolute inset-0 h-full w-full object-cover"
          onError={() => setImageFailed(true)}
        />
      ) : (
        <div className="absolute inset-0 flex flex-col items-center justify-center gap-3 bg-slate-100 p-5 text-center">
          <Armchair className="h-8 w-8 text-slate-400" />
          <span className="text-sm font-medium text-slate-500">{label}</span>
          <span className="text-xs text-slate-400">
            Foto belum tersedia
          </span>
        </div>
      )}
    </div>
  );
}
export default function SewaMobilInnovaTangerangPage() {
  const [activeUnitId, setActiveUnitId] = useState('reborn');
  const activeUnit =
    units.find((unit) => unit.id === activeUnitId) ?? units[0];
  const whatsappUrl = createWhatsAppUrl(activeUnit.name);
  return (
    <main className="min-h-screen overflow-hidden bg-white text-slate-900">
      <Navbar />
      {/* HERO */}
      <section className="relative overflow-hidden bg-[#07111f]">
        <div className="absolute inset-0">
          <img
            src="/assets/images/REBORN.jpeg"
            alt="Sewa mobil Toyota Innova Tangerang NAYVERA"
            className="h-full w-full object-cover opacity-30"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-[#07111f] via-[#07111f]/90 to-[#07111f]/45" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#07111f] via-transparent to-transparent" />
        </div>
        <div className="relative mx-auto grid min-h-[650px] max-w-7xl items-center gap-12 px-6 py-24 lg:grid-cols-[1.1fr_.9fr] lg:px-8">
          <div>
            <div className="mb-6 inline-flex items-center gap-2 rounded-full border border-[#d4af37]/40 bg-[#d4af37]/10 px-4 py-2 text-sm font-semibold text-[#e4c45a]">
              <MapPin size={16} />
              Rental Innova Tangerang
            </div>
            <h1 className="text-4xl font-extrabold leading-tight tracking-tight text-white sm:text-5xl lg:text-6xl">
              Sewa Mobil Innova
              <span className="mt-2 block text-[#d4af37]">
                Tangerang
              </span>
            </h1>
            <p className="mt-6 max-w-2xl text-base leading-8 text-slate-300 sm:text-lg">
              Butuh Toyota Innova untuk perjalanan keluarga, bisnis, antar
              jemput bandara, atau perjalanan luar kota? Pilih Innova Reborn,
              Zenix, maupun Venturer sesuai kebutuhan perjalanan Anda.
            </p>
            <div className="mt-8 flex flex-col gap-3 sm:flex-row">
              <a
                href={whatsappUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center gap-2 rounded-xl bg-[#d4af37] px-6 py-4 font-bold text-[#07111f] transition hover:bg-[#e4c45a]"
              >
                <MessageCircle size={19} />
                Tanya Harga & Booking
                <ArrowRight size={18} />
              </a>
              <a
                href="#pilihan-unit"
                className="inline-flex items-center justify-center rounded-xl border border-white/20 px-6 py-4 font-semibold text-white transition hover:border-[#d4af37] hover:bg-white/5"
              >
                Pilih Unit Innova
              </a>
            </div>
            <div className="mt-10 grid grid-cols-2 gap-5 sm:grid-cols-3">
              {[
                ['3 Pilihan', 'Tipe Innova'],
                ['Driver', 'Pilihan layanan'],
                ['Tangerang', 'Area layanan'],
              ].map(([value, label]) => (
                <div key={label} className="border-l border-[#d4af37]/60 pl-4">
                  <div className="font-bold text-[#e4c45a]">{value}</div>
                  <div className="mt-1 text-xs text-slate-400">{label}</div>
                </div>
              ))}
            </div>
          </div>
          <div className="rounded-3xl border border-white/10 bg-white/[0.06] p-5 backdrop-blur-sm sm:p-7">
            <p className="text-sm font-bold uppercase tracking-[0.18em] text-[#e4c45a]">
              Pilihan Kendaraan
            </p>
            <h2 className="mt-3 text-2xl font-bold text-white">
              Innova sesuai kebutuhan Anda
            </h2>
            <div className="mt-6 space-y-3">
              {units.map((unit) => (
                <button
                  key={unit.id}
                  type="button"
                  onClick={() => setActiveUnitId(unit.id)}
                  className={`flex w-full items-center justify-between gap-4 rounded-2xl border p-4 text-left transition ${
                    activeUnitId === unit.id
                      ? 'border-[#d4af37] bg-[#d4af37]/10'
                      : 'border-white/10 bg-white/[0.03] hover:border-white/30'
                  }`}
                >
                  <div>
                    <div className="font-bold text-white">{unit.name}</div>
                    <div className="mt-1 text-sm text-slate-400">
                      {unit.category} · {unit.capacity}
                    </div>
                  </div>
                  <CheckCircle2
                    size={21}
                    className={
                      activeUnitId === unit.id
                        ? 'shrink-0 text-[#e4c45a]'
                        : 'shrink-0 text-slate-500'
                    }
                  />
                </button>
              ))}
            </div>
            <a
              href={whatsappUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-5 inline-flex w-full items-center justify-center gap-2 rounded-xl bg-[#d4af37] px-5 py-3.5 font-bold text-[#07111f] transition hover:bg-[#e4c45a]"
            >
              Tanya {activeUnit.name}
              <ArrowRight size={18} />
            </a>
          </div>
        </div>
      </section>
      {/* INTRO */}
      <section className="bg-white py-20">
        <div className="mx-auto grid max-w-7xl gap-12 px-6 lg:grid-cols-[1.1fr_.9fr] lg:px-8">
          <div>
            <p className="text-sm font-bold uppercase tracking-[0.2em] text-[#b89528]">
              Rental Mobil Tangerang
            </p>
            <h2 className="mt-3 text-3xl font-extrabold leading-tight text-[#07111f] sm:text-4xl">
              Pilihan Innova untuk
              <span className="text-[#b89528]"> Perjalanan Lebih Nyaman</span>
            </h2>
            <p className="mt-6 leading-8 text-slate-600">
              NAYVERA INDO TRANSPORT menyediakan pilihan sewa Toyota Innova
              untuk berbagai kebutuhan perjalanan di Tangerang dan sekitarnya.
              Anda dapat memilih Innova Reborn, Innova Zenix, atau Innova
              Venturer berdasarkan preferensi kendaraan dan kebutuhan perjalanan.
            </p>
            <p className="mt-4 leading-8 text-slate-600">
              Layanan dapat dikonsultasikan untuk perjalanan keluarga,
              kegiatan bisnis, penjemputan tamu, antar jemput bandara, hingga
              perjalanan luar kota. Informasi harga, jadwal, dan ketersediaan
              unit akan dikonfirmasi sebelum pemesanan.
            </p>
          </div>
          <div className="rounded-3xl bg-[#07111f] p-8">
            <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-[#d4af37]/15 text-[#e4c45a]">
              <ShieldCheck size={25} />
            </div>
            <h3 className="mt-6 text-2xl font-bold text-white">
              Sesuaikan dengan Kebutuhan Perjalanan
            </h3>
            <div className="mt-6 space-y-4">
              {[
                'Pilihan tipe Innova untuk berbagai kebutuhan',
                'Konsultasi layanan dengan driver atau lepas kunci',
                'Pilihan perjalanan keluarga dan bisnis',
                'Area Tangerang dan rute luar kota tertentu',
                'Konfirmasi ketersediaan melalui WhatsApp',
              ].map((item) => (
                <div key={item} className="flex gap-3">
                  <CheckCircle2
                    size={20}
                    className="mt-0.5 shrink-0 text-[#d4af37]"
                  />
                  <span className="text-sm leading-6 text-slate-300">
                    {item}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
      {/* PILIHAN UNIT */}
      <section id="pilihan-unit" className="scroll-mt-24 bg-slate-50 py-20">
        <div className="mx-auto max-w-7xl px-6 lg:px-8">
          <div className="max-w-3xl">
            <p className="text-sm font-bold uppercase tracking-[0.2em] text-[#b89528]">
              Pilihan Unit
            </p>
            <h2 className="mt-3 text-3xl font-extrabold text-[#07111f] sm:text-4xl">
              Galeri Toyota Innova
              <span className="text-[#b89528]"> Tangerang</span>
            </h2>
            <p className="mt-5 leading-8 text-slate-600">
              Pilih tipe kendaraan untuk melihat galeri dan detail unit.
              Foto interior tambahan dapat ditampilkan setelah file gambar
              interior masing-masing kendaraan tersedia di folder public.
            </p>
          </div>
          <div className="mt-8 flex flex-wrap gap-3">
            {units.map((unit) => (
              <button
                key={unit.id}
                type="button"
                onClick={() => setActiveUnitId(unit.id)}
                className={`rounded-xl border px-5 py-3 text-sm font-bold transition ${
                  activeUnitId === unit.id
                    ? 'border-[#07111f] bg-[#07111f] text-white'
                    : 'border-slate-300 bg-white text-slate-700 hover:border-[#b89528]'
                }`}
              >
                {unit.name}
              </button>
            ))}
          </div>
          <div className="mt-8 grid gap-6 lg:grid-cols-[1.15fr_.85fr]">
            <div>
              <PhotoPlaceholder
                path={activeUnit.exterior}
                alt={activeUnit.altExterior}
                label={`Foto eksterior ${activeUnit.name}`}
                className="aspect-[16/10] bg-slate-200"
              />
              <div className="mt-4 grid grid-cols-2 gap-4">
                <PhotoPlaceholder
                  path={activeUnit.interior}
                  alt={activeUnit.altInterior}
                  label={`Interior ${activeUnit.name} — foto 1`}
                  className="aspect-[4/3]"
                />
                {/* ✅ INI YANG DIPERBAIKI — pakai activeUnit.interior2 */}
                <PhotoPlaceholder
                  path={activeUnit.interior2}
                  alt={activeUnit.altInterior2}
                  label={`Interior ${activeUnit.name} — foto 2`}
                  className="aspect-[4/3]"
                />
              </div>
            </div>
            <div className="flex flex-col rounded-3xl border border-slate-200 bg-white p-6 sm:p-8">
              <span className="w-fit rounded-full bg-[#d4af37]/15 px-3 py-1.5 text-xs font-bold uppercase tracking-wider text-[#8c6b12]">
                {activeUnit.category}
              </span>
              <h3 className="mt-5 text-2xl font-extrabold text-[#07111f] sm:text-3xl">
                {activeUnit.name}
              </h3>
              <p className="mt-4 leading-7 text-slate-600">
                {activeUnit.description}
              </p>
              <div className="mt-6 space-y-4 border-y border-slate-100 py-5">
                <div className="flex items-center gap-3">
                  <Users size={19} className="text-[#b89528]" />
                  <span className="text-sm text-slate-700">
                    {activeUnit.capacity}
                  </span>
                </div>
                <div className="flex items-center gap-3">
                  <Gauge size={19} className="text-[#b89528]" />
                  <span className="text-sm text-slate-700">
                    Transmisi: {activeUnit.transmission}
                  </span>
                </div>
                <div className="flex items-center gap-3">
                  <Luggage size={19} className="text-[#b89528]" />
                  <span className="text-sm text-slate-700">
                    Bahan bakar: {activeUnit.fuel}
                  </span>
                </div>
              </div>
              <h4 className="mt-6 font-bold text-[#07111f]">
                Cocok untuk kebutuhan:
              </h4>
              <div className="mt-4 space-y-3">
                {activeUnit.advantages.map((advantage) => (
                  <div key={advantage} className="flex gap-3">
                    <CheckCircle2
                      size={18}
                      className="mt-0.5 shrink-0 text-[#b89528]"
                    />
                    <span className="text-sm leading-6 text-slate-600">
                      {advantage}
                    </span>
                  </div>
                ))}
              </div>
              <a
                href={createWhatsAppUrl(activeUnit.name)}
                target="_blank"
                rel="noopener noreferrer"
                className="mt-8 inline-flex items-center justify-center gap-2 rounded-xl bg-[#07111f] px-5 py-4 font-bold text-white transition hover:bg-[#132943]"
              >
                <MessageCircle size={19} />
                Tanya Harga & Ketersediaan
                <ArrowRight size={18} />
              </a>
            </div>
          </div>
        </div>
      </section>
      {/* KEUNGGULAN */}
      <section className="bg-white py-20">
        <div className="mx-auto max-w-7xl px-6 lg:px-8">
          <div className="max-w-3xl">
            <p className="text-sm font-bold uppercase tracking-[0.2em] text-[#b89528]">
              Mengapa NAYVERA
            </p>
            <h2 className="mt-3 text-3xl font-extrabold text-[#07111f] sm:text-4xl">
              Rental Innova untuk
              <span className="text-[#b89528]"> Berbagai Kebutuhan</span>
            </h2>
            <p className="mt-5 leading-8 text-slate-600">
              Pilih kendaraan berdasarkan tujuan, jumlah penumpang, dan
              kebutuhan perjalanan. Admin NAYVERA membantu memberikan
              informasi layanan sebelum Anda melakukan pemesanan.
            </p>
          </div>
          <div className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
            {[
              {
                icon: ShieldCheck,
                title: 'Pilihan Kendaraan',
                text: 'Tersedia pilihan Innova Reborn, Zenix, dan Venturer sesuai ketersediaan unit.',
              },
              {
                icon: Users,
                title: 'Kebutuhan Keluarga',
                text: 'Pilihan MPV untuk perjalanan bersama keluarga maupun rekan.',
              },
              {
                icon: BriefcaseBusiness,
                title: 'Perjalanan Bisnis',
                text: 'Dapat dikonsultasikan untuk meeting, kunjungan kerja, dan penjemputan tamu.',
              },
              {
                icon: Plane,
                title: 'Antar Jemput Bandara',
                text: 'Sampaikan jadwal penerbangan dan lokasi penjemputan untuk pengecekan layanan.',
              },
              {
                icon: Route,
                title: 'Rute Fleksibel',
                text: 'Informasikan tujuan dan durasi perjalanan untuk konfirmasi ketentuan sewa.',
              },
              {
                icon: MessageCircle,
                title: 'Konsultasi WhatsApp',
                text: 'Hubungi admin untuk membahas unit, jadwal, paket, dan persyaratan.',
              },
            ].map((item) => {
              const Icon = item.icon;
              return (
                <article
                  key={item.title}
                  className="rounded-2xl border border-slate-200 bg-white p-6 transition hover:border-[#d4af37]/60 hover:shadow-lg"
                >
                  <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-[#07111f] text-[#e4c45a]">
                    <Icon size={22} />
                  </div>
                  <h3 className="mt-5 text-lg font-bold text-[#07111f]">
                    {item.title}
                  </h3>
                  <p className="mt-3 text-sm leading-7 text-slate-600">
                    {item.text}
                  </p>
                </article>
              );
            })}
          </div>
        </div>
      </section>
      {/* LAYANAN */}
      <section className="bg-[#07111f] py-20">
        <div className="mx-auto max-w-7xl px-6 lg:px-8">
          <div className="max-w-3xl">
            <p className="text-sm font-bold uppercase tracking-[0.2em] text-[#e4c45a]">
              Layanan NAYVERA
            </p>
            <h2 className="mt-3 text-3xl font-extrabold text-white sm:text-4xl">
              Layanan Sewa Mobil
              <span className="text-[#d4af37]"> Innova Tangerang</span>
            </h2>
            <p className="mt-5 leading-8 text-slate-400">
              Konsultasikan kebutuhan perjalanan agar pilihan unit dan jenis
              layanan dapat disesuaikan.
            </p>
          </div>
          <div className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
            {services.map((service) => {
              const Icon = service.icon;
              return (
                <article
                  key={service.title}
                  className="rounded-2xl border border-white/10 bg-white/[0.04] p-6 transition hover:border-[#d4af37]/60 hover:bg-white/[0.07]"
                >
                  <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-[#d4af37]/10 text-[#e4c45a]">
                    <Icon size={23} />
                  </div>
                  <h3 className="mt-5 text-xl font-bold text-white">
                    {service.title}
                  </h3>
                  <p className="mt-3 text-sm leading-7 text-slate-400">
                    {service.description}
                  </p>
                </article>
              );
            })}
          </div>
        </div>
      </section>
      {/* AREA LAYANAN */}
      <section className="bg-[#0b1726] py-20">
        <div className="mx-auto max-w-7xl px-6 lg:px-8">
          <p className="text-sm font-bold uppercase tracking-[0.2em] text-[#e4c45a]">
            Area Layanan
          </p>
          <h2 className="mt-3 max-w-3xl text-3xl font-extrabold text-white sm:text-4xl">
            Sewa Innova di Tangerang
            <span className="text-[#d4af37]"> dan Sekitarnya</span>
          </h2>
          <p className="mt-5 max-w-3xl leading-8 text-slate-400">
            Sampaikan lokasi penjemputan dan tujuan perjalanan saat
            menghubungi admin. Jangkauan layanan dan biaya perjalanan akan
            dikonfirmasi berdasarkan rute serta jenis layanan.
          </p>
          <div className="mt-9 grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-4">
            {areas.map((area) => (
              <div
                key={area}
                className="flex items-center gap-3 rounded-xl border border-white/10 bg-white/[0.04] p-4"
              >
                <MapPin size={17} className="shrink-0 text-[#e4c45a]" />
                <span className="text-sm text-slate-300">{area}</span>
              </div>
            ))}
          </div>
        </div>
      </section>
      {/* KEBUTUHAN PERJALANAN */}
      <section className="bg-slate-50 py-20">
        <div className="mx-auto max-w-7xl px-6 lg:px-8">
          <div className="text-center">
            <p className="text-sm font-bold uppercase tracking-[0.2em] text-[#b89528]">
              Kebutuhan Perjalanan
            </p>
            <h2 className="mt-3 text-3xl font-extrabold text-[#07111f] sm:text-4xl">
              Innova untuk Aktivitas
              <span className="text-[#b89528]"> Anda</span>
            </h2>
          </div>
          <div className="mt-10 grid gap-5 md:grid-cols-3">
            {[
              {
                title: 'Keluarga dan Wisata',
                text: 'Untuk liburan, acara keluarga, kunjungan, dan perjalanan bersama.',
              },
              {
                title: 'Bisnis dan Perusahaan',
                text: 'Untuk meeting, kunjungan klien, perjalanan dinas, dan tamu perusahaan.',
              },
              {
                title: 'Bandara dan Luar Kota',
                text: 'Untuk kebutuhan antar jemput bandara dan rute luar kota sesuai kesepakatan.',
              },
            ].map((item) => (
              <article
                key={item.title}
                className="rounded-2xl border border-slate-200 bg-white p-7"
              >
                <h3 className="text-xl font-bold text-[#07111f]">
                  {item.title}
                </h3>
                <p className="mt-3 text-sm leading-7 text-slate-600">
                  {item.text}
                </p>
              </article>
            ))}
          </div>
        </div>
      </section>
      {/* CARA BOOKING */}
      <section className="bg-white py-20">
        <div className="mx-auto max-w-7xl px-6 lg:px-8">
          <div className="text-center">
            <p className="text-sm font-bold uppercase tracking-[0.2em] text-[#b89528]">
              Cara Booking
            </p>
            <h2 className="mt-3 text-3xl font-extrabold text-[#07111f] sm:text-4xl">
              Cara Memesan
              <span className="text-[#b89528]"> Innova</span>
            </h2>
          </div>
          <div className="mx-auto mt-10 grid max-w-5xl gap-5 md:grid-cols-3">
            {[
              {
                number: '01',
                title: 'Pilih Unit',
                text: 'Tentukan Innova Reborn, Zenix, atau Venturer yang diminati.',
              },
              {
                number: '02',
                title: 'Kirim Detail',
                text: 'Sampaikan tanggal, durasi, lokasi jemput, tujuan, dan jenis layanan.',
              },
              {
                number: '03',
                title: 'Konfirmasi',
                text: 'Admin membantu mengecek ketersediaan serta menginformasikan paket dan ketentuan.',
              },
            ].map((step) => (
              <article
                key={step.number}
                className="rounded-2xl border border-slate-200 bg-slate-50 p-7"
              >
                <div className="text-4xl font-black text-[#d4af37]/50">
                  {step.number}
                </div>
                <h3 className="mt-4 text-xl font-bold text-[#07111f]">
                  {step.title}
                </h3>
                <p className="mt-3 text-sm leading-7 text-slate-600">
                  {step.text}
                </p>
              </article>
            ))}
          </div>
          <div className="mt-9 text-center">
            <a
              href={whatsappUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-2 rounded-xl bg-[#d4af37] px-7 py-4 font-bold text-[#07111f] transition hover:bg-[#e4c45a]"
            >
              <MessageCircle size={19} />
              Konsultasi via WhatsApp
              <ArrowRight size={18} />
            </a>
          </div>
        </div>
      </section>
      {/* FAQ */}
      <section className="bg-slate-50 py-20">
        <div className="mx-auto max-w-4xl px-6 lg:px-8">
          <div className="text-center">
            <p className="text-sm font-bold uppercase tracking-[0.2em] text-[#b89528]">
              FAQ
            </p>
            <h2 className="mt-3 text-3xl font-extrabold text-[#07111f] sm:text-4xl">
              Pertanyaan Seputar
              <span className="text-[#b89528]"> Sewa Innova</span>
            </h2>
          </div>
          <div className="mt-10 space-y-4">
            {faqs.map((faq) => (
              <details
                key={faq.question}
                className="group rounded-2xl border border-slate-200 bg-white"
              >
                <summary className="flex cursor-pointer list-none items-center justify-between gap-4 p-5 font-semibold text-[#07111f] sm:p-6">
                  <span>{faq.question}</span>
                  <ChevronDown
                    size={20}
                    className="shrink-0 text-[#b89528] transition group-open:rotate-180"
                  />
                </summary>
                <div className="border-t border-slate-100 px-5 pb-6 pt-4 text-sm leading-7 text-slate-600 sm:px-6">
                  {faq.answer}
                </div>
              </details>
            ))}
          </div>
        </div>
      </section>
      {/* CTA */}
      <section className="relative overflow-hidden bg-[#07111f] py-20">
        <div className="absolute -right-24 -top-24 h-80 w-80 rounded-full bg-[#d4af37]/10 blur-3xl" />
        <div className="relative mx-auto max-w-4xl px-6 text-center lg:px-8">
          <p className="text-sm font-bold uppercase tracking-[0.2em] text-[#e4c45a]">
            NAYVERA INDO TRANSPORT
          </p>
          <h2 className="mt-4 text-3xl font-extrabold text-white sm:text-5xl">
            Butuh Sewa Innova di
            <span className="block text-[#d4af37]">Tangerang?</span>
          </h2>
          <p className="mx-auto mt-6 max-w-2xl leading-8 text-slate-300">
            Hubungi admin NAYVERA untuk menanyakan ketersediaan Innova Reborn,
            Zenix, atau Venturer. Sampaikan kebutuhan perjalanan Anda agar
            informasi kendaraan dan paket sewa dapat dikonfirmasi.
          </p>
          <a
            href={whatsappUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-8 inline-flex items-center justify-center gap-2 rounded-xl bg-[#d4af37] px-7 py-4 font-bold text-[#07111f] transition hover:bg-[#e4c45a]"
          >
            <MessageCircle size={19} />
            Hubungi NAYVERA
            <ArrowRight size={18} />
          </a>
        </div>
      </section>
      <Footer />
      <WhatsAppFloat />
    </main>
  );
}